var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-image)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.12527 0H14.1515L20.95 7.09345V20.8744C20.95 22.5996 19.5497 24 17.8247 24H6.12527C4.40028 24 3 22.5996 3 20.8744V3.12558C3 1.40042 4.40028 0 6.12527 0Z",
    fill: "#0AC963"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1414 0V7.03256H20.95L14.1414 0Z",
    fill: "white",
    fillOpacity: 0.301961
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0241 11.9951H8.9258C8.46919 11.9951 8.09375 12.3706 8.09375 12.8273V16.7038C8.09375 17.1604 8.46919 17.5359 8.9258 17.5359H15.0241C15.4807 17.5359 15.846 17.1604 15.846 16.7038V12.8273C15.846 12.3706 15.4807 11.9951 15.0241 11.9951ZM10.5899 13.0404C11.0871 13.0404 11.4828 13.4463 11.4828 13.9334C11.4828 14.4306 11.0871 14.8366 10.5899 14.8366C10.0927 14.8366 9.68683 14.4306 9.68683 13.9334C9.68683 13.4463 10.0927 13.0404 10.5899 13.0404ZM15.2981 16.7038C15.2981 16.856 15.1763 16.9879 15.0241 16.9879H8.9258C8.7736 16.9879 8.65183 16.856 8.65183 16.7038V16.5414L9.75785 15.4353L10.6711 16.3486C10.7827 16.4602 10.9552 16.4602 11.0668 16.3486L13.36 14.0552L15.2981 15.9934V16.7038Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-image"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.1332a251e9ab995d09e3cbea28cdd21e.svg";
export { ForwardRef as ReactComponent };